import type { Point } from '@geom';
import { FontData, fontsByFamily } from '@resources';
import type { TextDirection } from '@strings';
import type { Path as SvgPath } from '@svgdotjs/svg.js';
import { expectDefined } from '@utils';
import { type Font, type Subset, create } from 'fontkit';
import { pathForStringFromFontKit, type FontPathOpts } from './SVGFKUtils';

export enum FontExportMethod {
  FALLBACKS,
  EMBED,
  PATHS
}

export class VectorExportFont {
  #fontData: FontData;
  #method: FontExportMethod;
  #subset: Subset | undefined;
  #font: Font | undefined;
  needsFontFaceRule = false;

  constructor(family: string, method: FontExportMethod) {
    this.#fontData = expectDefined(fontsByFamily.get(family));
    this.#method = method;
  }

  get family(): string {
    return this.#fontData.family;
  }

  get familyWithFallbacks(): string {
    return this.#fontData.familyWithFallbacks;
  }

  get font(): Font {
    if (this.#font === undefined) {
      this.#font = create(Buffer.from(this.#fontData.buffer)) as Font;
    }
    return this.#font;
  }

  get subset(): Subset {
    if (this.#subset === undefined) {
      this.#subset = this.font.createSubset();
    }
    return this.#subset;
  }

  get method(): FontExportMethod {
    return this.#method;
  }

  // Only used for EMBED_SUBSETS.
  addStringToSubset(s: string) {
    const glyphRun = this.font.layout(s);
    glyphRun.glyphs.forEach(glyph => {
      this.subset.includeGlyph(glyph);
    });
  }

  // Only used for PATHS.
  addPathForString(
    s: string,
    position: Point,
    size: number,
    context: TextDirection,
    opts?: FontPathOpts
  ): SvgPath | undefined {
    if (this.family.toLowerCase().includes('color')) {
      return undefined;
    }
    // return pathForStringFromOpenType(expectDefined(this.otFont), s, position, size);
    return pathForStringFromFontKit(
      expectDefined(this.font),
      s,
      position,
      size,
      context,
      opts
    );
  }
}
